import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'attendance/'

const initialState = {
    attData: [],
    dateWiseAtt: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addManualAttendance = createAsyncThunk('att/ma', async (attData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'manualAttendance', attData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getDailyAttendance = createAsyncThunk('att/gda', async (attData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getDailyAttendance', attData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const menuSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.attData = []
            state.dateWiseAtt = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDailyAttendance.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getDailyAttendance.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.dateWiseAtt = action.payload
            })
            .addCase(getDailyAttendance.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.dateWiseAtt = []
            })
    }
})

export const { reset } = menuSlice.actions

export default menuSlice.reducer